import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight, FiClock, FiMapPin, FiUsers } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from '../utils/formatters';

const TourCard = ({ tour }) => {
  const { t } = useTranslation();
  if (!tour) return null;

  return (
    <article className="soft-card overflow-hidden">
      <div className="relative">
        <img
          src={tour.photoUrl || '/tour-placeholder.jpg'}
          alt={tour.tourName}
          className="h-64 w-full object-cover"
          onError={(event) => {
            event.currentTarget.src = '/tour-placeholder.jpg';
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-950/65 via-transparent to-transparent" />
        <div className="absolute left-4 top-4 flex gap-2">
          <span className="pill bg-white/90 text-slate-800">
            <FiClock className="text-teal-700" />
            {tour.duration || 1} {t('design.tourCard.hoursShort')}
          </span>
          <span className="pill bg-white/90 text-slate-800">
            <FiUsers className="text-teal-700" />
            {tour.participantCount || 0}
          </span>
        </div>
      </div>

      <div className="space-y-5 p-5">
        <div className="space-y-2">
          <h3 className="font-serif text-2xl font-semibold text-slate-900">{tour.tourName}</h3>
          <p className="flex items-center gap-2 text-sm text-slate-600">
            <FiMapPin className="text-teal-700" />
            {tour.tourStartAddress} - {tour.tourEndAddress}
          </p>
        </div>

        <div className="grid gap-3 sm:grid-cols-2">
          <div className="rounded-3xl border border-stone-200 bg-stone-50/80 p-4">
            <p className="text-xs uppercase tracking-[0.2em] text-stone-500">{t('design.tourCard.price')}</p>
            <p className="mt-2 font-serif text-2xl font-semibold text-slate-900">{formatCurrency(tour.price)}</p>
          </div>
          <div className="rounded-3xl border border-stone-200 bg-stone-50/80 p-4">
            <p className="text-xs uppercase tracking-[0.2em] text-stone-500">{t('design.tourCard.routeQuality')}</p>
            <p className="mt-2 text-base font-semibold text-slate-900">{tour.starRating || 4}/5 {t('design.tourCard.curated')}</p>
          </div>
        </div>

        <div className="flex gap-3">
          <Link to={`/tour/${tour.id}`} className="btn-ghost flex-1">
            {t('design.tourCard.explore')}
          </Link>
          <Link to={`/tour-reservation/${tour.id}`} className="btn-primary flex-1">
            {t('tours.book')}
            <FiArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </article>
  );
};

export default TourCard;
